import { useDimensions } from '@tecsinapse/cortex-react'
import { useCallback, useState } from 'react'
import { useSearchBiblioteca } from './use-search-biblioteca'
import { useGenerateDownloadLink } from './use-generate-download-link'
import { useBibliotecaFolderActions } from './use-biblioteca-folder-actions'
import { CONST_ROOT_FOLDER, ModeType } from '../utils/constants'
import { SelectedItemBiblioteca } from '@/modules/biblioteca-virtual/types/types'
import { parseAsStringEnum, useQueryState } from 'nuqs'

export const useBibliotecaVirtual = () => {
  const [isNewFolderOpen, setIsNewFolderOpen] = useState(false)

  const handleOpenNewFolder = useCallback(() => setIsNewFolderOpen(true), [])
  const handleCloseNewFolder = useCallback(() => setIsNewFolderOpen(false), [])
  const [isFolder, setIsFolder] = useState<boolean>(false)
  const [mode, setMode] = useQueryState(
    'mode',
    parseAsStringEnum(Object.values(ModeType)).withDefault(ModeType.GRID)
  )

  const { generateDownloadLink } = useGenerateDownloadLink()

  const { width } = useDimensions()
  const isMobile = width <= 768

  const { searchText, setSearchText, searchDebounce, isSearching } =
    useSearchBiblioteca()

  const {
    itemsPorPasta,
    loadingItemsPorPasta,
    pasta,
    loadingPasta,
    pastasOptions,
    hasItems
  } = useBibliotecaFolderActions()

  const isRoot = pasta?.id === CONST_ROOT_FOLDER

  const hasWritePermission = pasta?.permissoesAcessoUsuarioLogado.some(
    permissao => permissao?.id === 'LEITURA_ESCRITA'
  )

  const pastas = itemsPorPasta?.content?.filter(item => item?.isPasta)
  const arquivos = itemsPorPasta?.content?.filter(item => !item?.isPasta)
  const images = itemsPorPasta?.content?.filter(item => item?.arquivoImagem)

  const showItensList = mode === ModeType.LIST
  const showItensModule = mode === ModeType.GRID
  const dontShowUploadUI = hasItems || isRoot || isSearching

  const isItemSelected = (rows: SelectedItemBiblioteca[], itemId: string) =>
    rows.some(row => row.data.id === itemId && row.selected)

  return {
    searchText,
    setSearchText,
    pasta,
    loadingPasta,
    isSearching,
    searchDebounce,
    pastas,
    isRoot,
    loadingPastas: loadingItemsPorPasta,
    hasWritePermission,
    isItemSelected,
    itemsPorPasta,
    pastasOptions,
    generateDownloadLink,
    mode,
    setMode,
    isFolder,
    setIsFolder,
    isNewFolderOpen,
    handleOpenNewFolder,
    handleCloseNewFolder,
    showItensList,
    showItensModule,
    dontShowUploadUI,
    arquivos,
    isMobile,
    images
  }
}
